import { createSlice } from '@reduxjs/toolkit';
import AuthService from '../services/authService';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  profileDetails: null,
  isLoading: true,
  isDistributor: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      state.isAuthenticated = true;
      state.isLoading = false;
      AuthService.setAuth({ token, user });
    },
    clearAuth(state) {
      Object.assign(state, initialState);
      AuthService.clearAuth();
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setDistributor(state, action) {
      state.isDistributor = action.payload;
    },
    setProfileDetails(state, action) {
      state.profileDetails = action.payload;
    }
  }
});

export const {
  setCredentials,
  clearAuth,
  setLoading,
  setDistributor,
  setProfileDetails
} = authSlice.actions;
export default authSlice.reducer;
